export default "__VITE_ASSET__BvwgeA0c__"